module.exports = __webpack_public_path__ + "img/common-popup.a9da86f5.png";